import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    services: [
      { name: 'Management Consulting', path: '/services#management' },
      { name: 'Digital Transformation', path: '/services#digital' },
      { name: 'Marketing Strategy', path: '/services#marketing' },
      { name: 'Operations Optimization', path: '/services#operations' },
    ],
    company: [
      { name: 'About Us', path: '/about' },
      { name: 'Our Approach', path: '/#approach' },
      { name: 'Industries Served', path: '/services#industries' },
      { name: 'Contact', path: '/contact' },
    ],
    resources: [
      { name: 'Why IRS Ventures', path: '/#why-choose' },
      { name: 'Request Consultation', path: '/contact' },
    ],
    industries: [
      { name: 'Private Practices', path: '/services#industries' },
      { name: 'Clinical Groups', path: '/services#industries' },
      { name: 'Specialty Clinics', path: '/services#industries' },
    ],
  };

  return (
    <footer className="bg-navy-dark text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-3">
            <img
              src="https://public.readdy.ai/ai/img_res/81550871-f738-4005-8be0-776988e2bbe6.png"
              alt="IRS Ventures LLC"
              className="h-12 w-auto mb-6"
            />
            <p className="text-sm text-gray-light mb-4 leading-relaxed">
              Strategic consulting for modern clinical practices
            </p>
            <p className="text-xs text-gold/40 uppercase tracking-wider">
              Established in Kentucky
            </p>
          </div>

          <div className="md:col-span-5 grid grid-cols-2 sm:grid-cols-4 gap-8">
            <div>
              <h4 className="text-xs uppercase tracking-widest text-gold mb-4 font-semibold">
                Services
              </h4>
              <ul className="space-y-3">
                {footerLinks.services.map((link) => (
                  <li key={link.name}>
                    <a
                      href={link.path}
                      className="text-sm text-gray-light hover:text-gold transition-all duration-200 hover:translate-x-0.5 inline-block cursor-pointer"
                    >
                      {link.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-xs uppercase tracking-widest text-gold mb-4 font-semibold">
                Company
              </h4>
              <ul className="space-y-3">
                {footerLinks.company.map((link) => (
                  <li key={link.name}>
                    <a
                      href={link.path}
                      className="text-sm text-gray-light hover:text-gold transition-all duration-200 hover:translate-x-0.5 inline-block cursor-pointer"
                    >
                      {link.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-xs uppercase tracking-widest text-gold mb-4 font-semibold">
                Resources
              </h4>
              <ul className="space-y-3">
                {footerLinks.resources.map((link) => (
                  <li key={link.name}>
                    <a
                      href={link.path}
                      className="text-sm text-gray-light hover:text-gold transition-all duration-200 hover:translate-x-0.5 inline-block cursor-pointer"
                    >
                      {link.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-xs uppercase tracking-widest text-gold mb-4 font-semibold">
                Industries
              </h4>
              <ul className="space-y-3">
                {footerLinks.industries.map((link) => (
                  <li key={link.name}>
                    <a
                      href={link.path}
                      className="text-sm text-gray-light hover:text-gold transition-all duration-200 hover:translate-x-0.5 inline-block cursor-pointer"
                    >
                      {link.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="md:col-span-4">
            <h4 className="text-base font-semibold mb-6">Connect With Us</h4>
            <div className="space-y-4 mb-6">
              <a
                href="tel:8665195999"
                className="flex items-center text-sm text-gray-light hover:text-gold transition-colors duration-200 cursor-pointer"
              >
                <i className="ri-phone-line text-lg mr-3"></i>
                (866) 519-5999
              </a>
              <a
                href="mailto:admin@irsventures.com"
                className="flex items-center text-sm text-gray-light hover:text-gold transition-colors duration-200 cursor-pointer"
              >
                <i className="ri-mail-line text-lg mr-3"></i>
                admin@irsventures.com
              </a>
            </div>
            <Link
              to="/contact"
              className="block w-full px-6 py-3 bg-gold text-navy-primary text-sm font-semibold text-center rounded-lg hover:bg-gold-light transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              Request Strategy Call
            </Link>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row justify-between items-center">
          <p className="text-xs text-gray-light mb-4 sm:mb-0">
            © {currentYear} IRS Ventures LLC. All rights reserved.
          </p>
          <div className="flex items-center space-x-6">
            <a
              href="https://readdy.ai/?ref=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="text-xs text-gray-light hover:text-gold transition-colors duration-200 cursor-pointer"
            >
              Website Builder
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;